/** Clamp a raw value to an integer 0–100 percent. */
export const clampPercent = (value) =>
  Math.max(0, Math.min(100, Math.round(Number(value) || 0)));

export const easeOutCubic = (t) => 1 - (1 - t) ** 3;
